import { AppData, Log, Router } from '@lightningjs/sdk'
import { AdSdkConfig, AppApiConfig, LayoutConfig } from '../app-api-config'
import GridViewModel, { FocusInfo } from '../components/grid/grid-view-model'
import { ItemNode } from "../components/grid/ItemNode"
import { clearRecentlyWatched, fetchData, getBookmarkingData, getIndexUrl, getQueueItemUrl, getSearchItemUrl, getSimilarVideosUrl } from './data-service'
import NavigationStack from './navigation-stack'
import RowList from '../components/grid/row-model'
import { AppSetup } from '../app-setup'
import { AdHandler } from '../ad-handler'
import { FreeWheelAds } from '../ads-freewheel'
import { Logger } from '../logger'
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE, GRIDTYPE, ITEMTYPE, REQUEST_STATUS } from '../enum'
import QueueManager from '../queue-manager'
import { Deeplink } from '../deeplink'
import { Helper } from '../helper'
import BookmarkingManager from '../bookmarking-manager'
import IMAAdHandler from '../ima-sdk/ima-ad-handler'
import EPGManager from '../components/epg/epg-model'
import BlockingManager from '../blocking-manager'
import { IDialogueButton, IDialogueInfo } from '../interfaces'
import childApp from '../child-app'
import { AdObj } from '../vast-parser'
import MultiBannerManager from '../multi-banner-manager'

export interface IAppModel {
    l1CategoryToLoad: number
    isMainApp: boolean
    siteId: string
    isInitialized: boolean
    appApiConfig: AppApiConfig
    adHandler: AdHandler
    imaAdHandler: IMAAdHandler
    suspendedAppStack: GridViewModel[]
}
export default class AppModel implements IAppModel {
    l1CategoryToLoad = -1
    isMainApp = false
    siteId = ''
    isInitialized = false
    appApiConfig!: AppApiConfig
    suspendedAppStack: GridViewModel[] = []
    isTopCarouselVisible: boolean = false

    deeplink: Deeplink = new Deeplink()
    deeplinkGrid!: GridViewModel
    dynidGrid: GridViewModel | undefined = undefined
    queueGrid!: GridViewModel
    searchGrid!: GridViewModel
    videoPlaylistGrid!: GridViewModel
    similarGrid!: GridViewModel
    selectScreenLiveGrid!: GridViewModel
    topCarouselGrid: GridViewModel | undefined

    navigation!: NavigationStack
    queueManager!: QueueManager
    bookmarkingManager!: BookmarkingManager
    epgManager!: EPGManager
    blockingManager!: BlockingManager
    multiBannerManager: MultiBannerManager = new MultiBannerManager()

    adObj = {
        adActivation: false,
        adInterval: false,
        adProbability: false,
        adUrl: "",
        adCounter: 0,
        enableMidAd: false,
        midAdTimeInterval: 0,
        midAdRepeatMode: false,
        createView: 0,
        start: 0,
        firstQuartile: 0,
        midPoint: 0,
        thirdQuartile: 0,
        complete: 0,
        adDetails: {},
        adsdklistPriorities: new Array(),
        firstadInterval: 0,
        nonmidrollsize: 0,
        midrollsize: 0,
        adsdklist: new Array(),
    }

    ads = {
        adDisplayContainer: null,
        requestInProgress: false,
        preRollAdsPlayed: 0,
        preRollAdsRequested: 0,
        midRollAdsPlayed: 0,
        midRollAdsRequested: 0,
        adPlaying: false,
        midAdPlaying: false,
        currentVodCuePoints: new Array(),
        currentVodPlayPoints: new Array(),
        currentVodPFPoints: new Array(),
        currentVodCuePointsCopy: new Array(),
        currentVodPFInfo: {},
        adResp: '',
        currentlyRequestedAdType: 'preroll',
        adSdkCalled: 0,
        adRequestedAgo: 0,
        shouldResumeVideo: true,
        currentAdTrackers: new Array(),
        defaultAdProvider: 'ima',
        adSdksChecked: new Array(),
        adSdksCount: 0,
        skippedPods: new Array(),
        adPaused: false,
        adPlayRequested: false,
        preRollRequestMade: false,
        adHangCheck: null,
        adHangProgress: 0,
        adTimeoutBeforeDiscard: 40,
        breakPointAdMapCounter: 0,
        lastPrerollTimestamp: 0,
        adBreakNumber: 0,
        adsPlaybackRemainingTime: 240,
        adsLabelTimer: null,
        adsPlayedTime: 0,
        adscurrentController: 'freewheel',
        adsInitialized: false,
    };

    bugAdsCache: { adObj: AdObj | null; status: 'idle' | 'loading' | 'ready' | 'empty' | 'error' } = {
        adObj: null,
        status: 'idle',
    };

    pauseAdsCache: {
        adObj: AdObj | null;
        status: 'idle' | 'loading' | 'ready' | 'empty' | 'error';
        nextIndex: number;
    } = {
            adObj: null,
            status: 'idle',
            nextIndex: 0,
        };

    themesObj = {
        ageRatingColor: '',
        titleColor: '',
        textSize: 0,
        textcolor: '',
        gridfocuscolor: '',
        bgcolor: ''
    }

    adHandler: AdHandler = new AdHandler();
    imaAdHandler: IMAAdHandler = new IMAAdHandler();

    freeWheelAds = new FreeWheelAds().freeWheelAds;
    videoObj: any;
    adPlayObj: any;




    constructor(siteId: string, isMainApp = false) {
        this.siteId = siteId
        this.isMainApp = isMainApp
        this.appApiConfig = new AppApiConfig()
        this.navigation = new NavigationStack()
        this.queueManager = new QueueManager()
        this.bookmarkingManager = new BookmarkingManager()
        this.blockingManager = new BlockingManager()
        this.isInitialized = true
        window.currentApp = this
    }

    loadIndex = () => {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        return new Promise((resolve) => {
            let url = getIndexUrl(this.siteId)
            Log.info('Index.php request: ', url)
            const { appConfig } = AppData as AppSetup
            if (appConfig?.testIndexError) {
                url = 'https://index_404.php'
                //url.split('index.php').join('index_404.php')
            }
            fetchData(url).then((response) => {
                this.appApiConfig.init(response.data)
                Log.info('Index.php response: ', response.data, this.appApiConfig)
                this.multiBannerManager.init()
                resolve(true)
                this.initAdHandler();
                this.queueManager.init()
            })
                .catch((e) => {
                    const { platform } = AppData as AppSetup
                    Log.error('Index.php load error')
                    platform?.sendMetrics('error', { errorType: 'network', code: e.code, description: e.message })
                    resolve(false)
                })
        })
    }

    handleBackNavigation(prevPage = '') {
        const currentRoute: string = Router.getActiveRoute()?.split('/')[0]!
        Log.info('handleBackNavigation: ', currentRoute)
        let grid = this.navigation.getCurrentGrid()
        const { platform, appConfig } = AppData as AppSetup
        if (currentRoute == 'video-screen' || currentRoute == 'video-screen-live' || currentRoute == 'splash') {
            if (!platform.isVideoSuspended) {
                grid = this.navigation.getCurrentGrid();
                if (grid && (grid.type == GRIDTYPE.DYNID || grid.type == GRIDTYPE.LIVE_SELECTSCREEN || grid.type == GRIDTYPE.TOP_CAROUSEL || grid.type == GRIDTYPE.SIMILAR_VIDEOS || grid.type == GRIDTYPE.QUEUE)) {
                    this.navigation.continuesStack.pop()
                }
                if (grid && grid.type === GRIDTYPE.GRID) {
                    appConfig.disableTopCarouselFocus = true;
                }
                if (this.dynidGrid) {
                    this.dynidGrid.destroy()
                    this.dynidGrid = undefined
                }
            }
            this._backToGridPage(currentRoute)
        } else if (currentRoute == 'search-screen' || currentRoute == 'settings-screen') {
            if (grid.type == GRIDTYPE.TOP_CAROUSEL) {
                this.navigation.continuesStack.pop()
            }
            if (prevPage === 'grid') {
                this._backToGridPage(currentRoute)
            } else if (prevPage === 'player') {
                this._backToPlayerPage();
            } else {
                this._backToGridPage(currentRoute)
            }
        } else if (currentRoute == 'mlp-grid-screen') {
            if (grid.isMlp && grid.mlpId !== 'search') {
                this.navigation.handleBack()
            }
            if (grid.type == GRIDTYPE.TOP_CAROUSEL) {
                this.navigation.continuesStack.pop()
            }
            const newGrid = this.navigation.getCurrentGrid();
            if (newGrid && newGrid.type === GRIDTYPE.GRID) {
                 appConfig.disableTopCarouselFocus = true;
            }
            this._backToGridPage(currentRoute)
        } else if (currentRoute == 'main-grid-screen') {
            //TBD - show app exit popup to user.
        } else if (currentRoute == 'cc-setting') {
            if (prevPage === 'grid') {
                this._backToGridPage(currentRoute)
            }
            this._backToGridPage(currentRoute)
        }
    }

    private _backToGridPage(currentRoute: any) {
        const { appState, platform } = AppData as AppSetup
        let grid = this.navigation.getCurrentGrid()
        if (!grid) {
            Router.navigate('main-grid-screen/' + 0, false)
            if (currentRoute == 'video-screen') {
                Logger.processUserAction('goBacktoHomescreenFromPlayer');
            } else if (currentRoute == 'mlp-grid-screen') {
                Logger.processUserAction('goBacktoHomescreenFromListoflistScreen');
            }
            return;
        } else if (grid.type == GRIDTYPE.SEARCH) {
            this.navigation.handleBack(false)
            const { appConfig } = AppData as AppSetup;
            appConfig.useHistory = true;
            Router.navigate('search-screen/grid', false)
            if (currentRoute == 'video-screen') {
                Logger.processUserAction('goBackToSearchResultsFromPlayer');
            }
        } else if (grid.type == GRIDTYPE.DEEPLINK) {
            //if (!platform.isVideoSuspended) {
                appState?.clearDeeplink()
                if (grid.isMlp) {
                    grid.type = GRIDTYPE.MLP;
                    let item: ItemNode = grid.channelInfo as ItemNode;
                    grid.mlpId = item.id
                    Router.navigate('mlp-grid-screen/' + item.id, false)
                    if (currentRoute == 'video-screen') {
                        Logger.processUserAction('goBacktoListoflistScreenFromPlayer');
                    }
                } else {
                    this.navigation.pop();
                    Router.navigate('main-grid-screen/' + 0, false)
                    if (currentRoute == 'video-screen') {
                        Logger.processUserAction('goBacktoHomescreenFromPlayer');
                    } else if (currentRoute == 'mlp-grid-screen') {
                        Logger.processUserAction('goBacktoHomescreenFromListoflistScreen');
                    }
                }
            //}
        } else {
            if (grid.isMlp) {
                Router.navigate('mlp-grid-screen/' + grid.mlpId, false)
                if (currentRoute == 'video-screen') {
                    Logger.processUserAction('goBacktoListoflistScreenFromPlayer');
                }
            } else {
                Router.navigate('main-grid-screen/' + this.l1CategoryToLoad, false)
                if (currentRoute == 'video-screen') {
                    Logger.processUserAction('goBacktoHomescreenFromPlayer');
                }
            }
        }
    }

    private _backToPlayerPage() {
        const grid = this.navigation.getCurrentGrid()
        const vodInfo: ItemNode = grid.getFocusedItem();
        if (vodInfo.feed_type == 'video') {
            Router.navigate('video-screen/' + vodInfo.node_id + '_search', false)
        }
    }



    destroy() {
    }

    /**
     * Clear only Similar Videos Grid to prevent it from showing on Home L1.
     * Called when user exits Similar Videos screen.
     */
    //XFIN-1258
    clearSimilarVideosGrid() {
        if (this.similarGrid !== undefined) {
            this.similarGrid.destroy()
            this.similarGrid = undefined as any
        }
    }

    loadL1 = (l1: string, reload?: boolean): GridViewModel => {
        let gridViewModel: GridViewModel
        const currentGrid = this.navigation.getCurrentGrid()
        if (parseInt(l1) !== this.l1CategoryToLoad || reload || (currentGrid && currentGrid.type !== GRIDTYPE.GRID)) {
            while (this.navigation.continuesStack.length > 1) {
                this.navigation.pop()
            }
            this.l1CategoryToLoad = parseInt(l1)
            this.multiBannerManager.refreshCreatives(this.l1CategoryToLoad)
            this.navigation.reset();
            this.clearSimilarVideosGrid()
            // Making top carousel grid null and marking the topcarousel is visible false before loading new l1.
            this.topCarouselGrid = undefined
            this.isTopCarouselVisible = false
            
            const currentChannel: any = this.appApiConfig.appConfig?.channels
            gridViewModel = new GridViewModel(currentChannel[this.l1CategoryToLoad])
            gridViewModel.type = GRIDTYPE.GRID
            this.navigation.push(gridViewModel)
        } else {
            if (currentGrid.type === GRIDTYPE.TOP_CAROUSEL) {
                gridViewModel = this.navigation.continuesStack.find(g => g.type === GRIDTYPE.GRID) || this.navigation.getCurrentGrid()
            } else {
                gridViewModel = this.navigation.getCurrentGrid()
            }
        }
        return gridViewModel
    }

    /**
    * @method loadShowPrefetch
    * @description Load the show prefetch grid with the given showInfo and id.
    * This is temporary prefetch made for autoPlay in heroBanner only for mlp and nested mlp in the main grid.
    * @param {ItemNode} showInfo - The show information to load.
    * @param {string} id - The id of the show.
    */
    loadShowPrefetch = (showInfo: ItemNode, id: string, parentGrid?: GridViewModel): GridViewModel => {
        const currentGrid = parentGrid || this.navigation.getCurrentGrid()

        const gridViewModel = new GridViewModel(showInfo, true, id)
        gridViewModel.type = GRIDTYPE.MLP
        gridViewModel.parentGrid = currentGrid
        if (currentGrid) {
            currentGrid.childGrid = gridViewModel
        }
        return gridViewModel
    }

    resolvePlayableItem = async (item: ItemNode, depth = 0, grids: GridViewModel[] = []): Promise<{ item: ItemNode, grids: GridViewModel[] }> => {
        if (depth > 5) {
            return { item, grids }
        }
        if (!item || (item.type !== 'listoflist' && item.type !== 'new-qid' && item.feed_type !== 'banner')) {
            return { item, grids }
        }
        const mlpGrid: GridViewModel = this.loadShowPrefetch(item, item.id)
        if (!mlpGrid) {
            return { item, grids }
        }
        try {
            await mlpGrid._init()
            mlpGrid.createGridListUI()
            grids.push(mlpGrid)
            let focusedItem: ItemNode = mlpGrid.getFocusedItem()
            if (!focusedItem) {
                return { item, grids }
            }
            if (this.blockingManager.isItemBlocked(focusedItem)) {
                focusedItem = (await this.scanAndSkipBlockedRowItem(mlpGrid)) || focusedItem
            }
            return await this.resolvePlayableItem(focusedItem, depth + 1, grids)
        } catch (e) {
            mlpGrid.destroy()
            throw e
        }
    }

    /**
    * @method scanAndSkipBlockedRowItem
    * @description Scan the current row of the given grid for the next unblocked item, starting
    * right after the focused item, and change focus to it. Mirrors Autoplay.scanAndSkipBlockedRowItemsInMlp.
    * @param {GridViewModel} grid - The grid whose current row should be scanned.
    */
    scanAndSkipBlockedRowItem = async (grid: GridViewModel): Promise<ItemNode | null> => {
        const focusInfo = grid.getFocusInfo()
        const rowLength = grid._getRowItemLength(focusInfo.focusRow)
        for (let i = focusInfo.foucsItem + 1; i < rowLength; i++) {
            const nextItem = await grid.getItemAt(focusInfo.focusRow, i)
            if (nextItem && !this.blockingManager.isItemBlocked(nextItem)) {
                grid.changeFocus({ focusRow: focusInfo.focusRow, foucsItem: i })
                return nextItem
            }
        }
        return null
    }

    loadShow = (showInfo: ItemNode, id: string): GridViewModel => {
        const currentGrid = this.navigation.getCurrentGrid()

        if (currentGrid.isMlp && currentGrid.mlpId == id) {
            return currentGrid
        }
        const gridViewModel = new GridViewModel(showInfo, true, id)
        gridViewModel.type = GRIDTYPE.MLP
        gridViewModel.parentGrid = currentGrid
        currentGrid.childGrid = gridViewModel
        this.navigation.push(gridViewModel)
        return gridViewModel
    }

    loadSearch = (searchStr: string) => {
        if (this.searchGrid !== undefined) {
            this.searchGrid.destroy()
        }
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
        const itemNode: ItemNode = new ItemNode()
        const scale = rowStyle.rowstyle == 'flat-movie' ? 1 : 0.85
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, 'search')
        const rowData = {
            description: 'search',
            dynamic_deeplink: '',
            feed_type: 'video',
            name: 'Search: ' + searchStr,
            row_height: rowStyle.row_height * scale,
            row_item_height: rowStyle.row_item_height * scale,
            row_item_width: rowStyle.row_item_width * scale,
            rowstyle: rowStyle.rowstyle,
            row_sub_type: '',
            row_type: 'mixed-content-row',
            url: getSearchItemUrl(searchStr)
        }
        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.type = GRIDTYPE.SEARCH
        this.searchGrid = gridViewModel
        return this.searchGrid
    }

    loadVideoPlaylist = () => {
        Log.info('loadVideoPlaylist', this.navigation.continuesStack)
        if (this.videoPlaylistGrid !== undefined) {
            this.videoPlaylistGrid.destroy()
        }
        let currentGrid: GridViewModel = this.navigation.getCurrentGrid();
        let focusInfo: FocusInfo = currentGrid.getFocusInfo();
        let currentRow: RowList = currentGrid.getRowAt(focusInfo.focusRow);
        let vodInfo: ItemNode = currentGrid.getFocusedItem()
        //const uiRow:any = currentGrid.getUiRowAt(focusInfo.focusRow);
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel: GridViewModel = new GridViewModel(itemNode, true, 'videoplaylist')
        let dynidGrid: GridViewModel
        let dynidRow: RowList
        let similarGrid: GridViewModel
        let similarRow: RowList

        if (currentGrid.type == GRIDTYPE.DYNID) {
            currentGrid = this.navigation.getNonDynamicGrid()
            focusInfo = currentGrid.getFocusInfo();
            currentRow = currentGrid.getRowAt(focusInfo.focusRow);
            vodInfo = currentGrid.getFocusedItem()
            dynidGrid = this.dynidGrid
            dynidRow = dynidGrid.getRowAt(0)!
            gridViewModel.add(dynidRow, 0)
            gridViewModel.add(currentRow, 1)
            focusInfo = dynidGrid.getFocusInfo();
        } else {
            currentRow.playlistRowName = 'Current video list'
            if (!Helper.isEmpty(vodInfo.deeplink_url)) {
                dynidGrid = this.loadDynid(vodInfo.deeplink_url, vodInfo.node_id, currentRow)
                dynidRow = dynidGrid.getRowAt(0)!
                gridViewModel.add(currentRow, 0)
                gridViewModel.add(dynidRow, 1)
            } else {
                gridViewModel.add(currentRow, 0)
            }
        }
        const { appConfig } = AppData as AppSetup
        if (appConfig?.enableSimilarVideorowinvideoplayer && vodInfo.feed_type == 'video' && vodInfo.node_id) {
            const showInfo: ItemNode | undefined = currentGrid.type == GRIDTYPE.MLP ? (currentGrid.channelInfo as ItemNode) : undefined
            similarGrid = this.loadSimilarVideos(showInfo ? (showInfo.node_id || showInfo.id) : vodInfo.node_id, showInfo ? ITEMTYPE.TVSHOW : vodInfo.item_type)
            similarRow = similarGrid.getRowAt(0)!
            gridViewModel.add(similarRow, gridViewModel.gridModel!.categoryList.length)
        }
        let hasQueueRow = false
        if (appConfig?.enableQueuerowinvideoplayer && appConfig?.enableQueueManagement) {
            const queueRow: RowList | undefined = this.queueGrid?.getRowAt(0)
            if (queueRow && queueRow.videos.length > 0) {
                gridViewModel.add(queueRow, gridViewModel.gridModel!.categoryList.length)
                hasQueueRow = true
            }
        }
        gridViewModel.type = GRIDTYPE.VIDEOPLAYLIST
        gridViewModel.createGridListUI()
        if (hasQueueRow && gridViewModel.uiList.length > 0) {
            gridViewModel.uiList[gridViewModel.uiList.length - 1].title = 'Queue'
        }
        gridViewModel.focusInfo = {
            focusRow: 0, foucsItem: focusInfo.foucsItem
        }
        this.videoPlaylistGrid = gridViewModel

        return this.videoPlaylistGrid
    }

    loadQueuePlaylist = (reload = false) => {
        const {appConfig} = AppData as AppSetup
        if (this.queueGrid !== undefined && (reload || !this.navigation.continuesStack.includes(this.queueGrid))) {
            this.queueGrid.destroy()
        }
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, GRIDTYPE.QUEUE)
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
        const rowData = {
            description: 'queue',
            dynamic_deeplink: '',
            feed_type: 'video',
            name: appConfig?.queueRowName,
            row_sub_type: '',
            row_type: 'queue',
            row_height: rowStyle.row_height,
            row_item_height: rowStyle.row_item_height,
            row_item_width: rowStyle.row_item_width,
            rowstyle: rowStyle.rowstyle,
            url: getQueueItemUrl()
        }

        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.type = GRIDTYPE.QUEUE
        this.queueGrid = gridViewModel
        return this.queueGrid
    }

    loadSimilarVideos(vodInfoId: string, itemType?: string) {
        if (this.similarGrid !== undefined && !this.navigation.continuesStack.includes(this.similarGrid)) {
            this.similarGrid.destroy()
        }
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, vodInfoId)
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
        const rowData = {
            description: 'similar',
            dynamic_deeplink: '',
            feed_type: 'video',
            name: Helper.isShowContent(itemType) ? 'Similar Shows' : 'Similar Videos',
            row_sub_type: '',
            row_type: 'mixed-content-row',
            row_height: rowStyle.row_height,
            row_item_height: rowStyle.row_item_height,
            row_item_width: rowStyle.row_item_width,
            rowstyle: rowStyle.rowstyle,
            url: getSimilarVideosUrl(vodInfoId, itemType)
        }
        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.createGridListUI()
        gridViewModel.type = GRIDTYPE.SIMILAR_VIDEOS
        this.similarGrid = gridViewModel
        return this.similarGrid
    }

    loadLiveTvfromSelectScreen(url) {
        if (this.selectScreenLiveGrid !== undefined) {
            this.selectScreenLiveGrid.destroy()
        }
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, '0')
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
        const rowData = {
            description: 'live tv from select',
            dynamic_deeplink: '',
            feed_type: 'live',
            name: 'Live Tv',
            row_sub_type: '',
            row_type: 'live',
            row_height: rowStyle.row_height,
            row_item_height: rowStyle.row_item_height,
            row_item_width: rowStyle.row_item_width,
            rowstyle: rowStyle.rowstyle,
            url: url
        }
        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.createGridListUI()
        gridViewModel.type = GRIDTYPE.LIVE_SELECTSCREEN
        this.selectScreenLiveGrid = gridViewModel
        return this.selectScreenLiveGrid
    }

    loadEpg(url?: any, rowlist?: RowList | RowList[], currIndex = 0): EPGManager {
        if (!this.epgManager || this.epgManager.url !== url) {
            this.epgManager = new EPGManager(url, rowlist)
        } else {
            if (rowlist) {
                const first = Array.isArray(rowlist) ? rowlist[0] : rowlist
                this.epgManager.rowLists = Array.isArray(rowlist) ? rowlist : [rowlist]
                this.epgManager.channelRowList = first
            }
            this.epgManager.currIndex = currIndex
            this.epgManager.loaded = false
        }
        return this.epgManager
    }

    loadDynid(dynidUrl, vodInfoId, currentRow) {
        if (this.dynidGrid !== undefined) {
            this.dynidGrid.destroy()
        }
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, vodInfoId)
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle(currentRow)
        const rowData = {
            description: 'dynid',
            dynamic_deeplink: '',
            feed_type: 'video',
            name: 'You may also like',
            row_sub_type: '',
            row_type: 'mixed-content-row',
            row_height: rowStyle.row_height,
            row_item_height: rowStyle.row_item_height,
            row_item_width: rowStyle.row_item_width,
            rowstyle: rowStyle.rowstyle,
            url: dynidUrl
        }
        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.createGridListUI()
        gridViewModel.type = GRIDTYPE.DYNID
        this.dynidGrid = gridViewModel
        return this.dynidGrid
    }

    loadDeeplinkInterrupt(playIdUrl: string) {
        const { appState } = AppData as AppSetup
        if (!Helper.isEmpty(playIdUrl)) {
            const deeplink = this.deeplink;
            deeplink.getDeeplinkingParams(playIdUrl, this);
            if (appState.playlistPlayMode && !appState.deeplinks.isInvalidPattern) {
                deeplink.loadPlaylistAndPlay();
                appState.isDeeplinkInterupped = true;
            } else {
                deeplink.handleError();
            }
        }
    }

    loadTopCarouselData(channel:any){
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, false, GRIDTYPE.TOP_CAROUSEL)
        const rowList = new RowList(channel)
        gridViewModel.add(rowList)
        gridViewModel.type = GRIDTYPE.TOP_CAROUSEL
        this.topCarouselGrid = gridViewModel
        Log.info('App-Model:',this.topCarouselGrid)
        this.isTopCarouselVisible = true
    }

    handleAppExit() {
        const { appState, platform } = AppData as AppSetup
        // If a child app (e.g. launched from a bug ad) is open, back/exit
        // returns to the previous app instead of exiting the whole app.
        if (appState && appState.appStack.length > 1) {
            childApp.closeChildApp(false)
            return true
        }
        if (platform?._shouldShowExitPopup) {
            const dialogInfo: IDialogueInfo = {
                title: 'Confirm',
                body: 'Are you sure you want to exit the app?',
                type: DIALOG_TYPE.APP_EXIT_BOX,
                buttons: [
                    {
                        w:250,
                        name: 'No',
                        index: 0,
                        action: DIALOG_BUTTON_ACTION.NO,
                        initialFocus: true,
                    },
                    {
                        w:250,
                        name: 'Yes',
                        index: 1,
                        action: DIALOG_BUTTON_ACTION.YES,
                        initialFocus: false
                    }
                ],
                callback: this.handleExitPopupHandler.bind(this)
            }
            const page = Router.getActivePage()
            page.widgets.dialog.showDialog(dialogInfo)
            Router.focusWidget('dialog')
            return true
        } else {
            Logger.processUserAction('userExitedViaRemoteDirectlyFromGrid');
            platform?.sendMetrics('close', { reason: "user exit on back" })
        }
    }

    handleExitPopupHandler(selected: IDialogueButton) {
        const { platform } = AppData as AppSetup
        if (selected.action == DIALOG_BUTTON_ACTION.YES) {
            Logger.processUserAction('userExitedViaRemoteDirectlyFromGrid');
            platform?.sendMetrics('close', { reason: "user exit on back" })
        } else {
            Router.focusPage()
        }
    }

    reloadAppOnParentalControlChange(aContent) {
        const { appConfig } = AppData as AppSetup;
        this.navigation.reset()
        appConfig.aContent = aContent
        Router.navigate('main-grid-screen/' + this.l1CategoryToLoad + '_true_' + new Date().getTime(), false)
    }

    /**
     * Find the next item in the grid
     * This method will loop through the current grid and find the next item that is not blocked.
     * If the current grid is a dynamic grid, it will switch to the dynamic grid and find the next item there.
     * If the current grid is a dynamic grid and there are no more items, it will pop the dynamic grid and continue searching in the previous grid.
     * If the current grid is not a dynamic grid, it will continue searching in the current grid until it finds the next item that is not blocked.
     * @returns {Promise<ItemNode>} - The next item that is not blocked.
    */
    findNextItem(): Promise<ItemNode> {
        return new Promise(async (resolve) => {
            let exit = false
            let vodItem: ItemNode | null = null
            let grid: GridViewModel | null = this.navigation.getCurrentGrid()
            let tempInfo = grid.getFocusInfo()
            let dynidGrid: any = this.dynidGrid || undefined

            while (!exit) {
                if (grid.type !== GRIDTYPE.DYNID) {
                    if (dynidGrid !== undefined) {
                        tempInfo.focusRow = 0
                        tempInfo.foucsItem = -1
                        grid = dynidGrid
                    }
                }
                vodItem = await grid.getNextItem(tempInfo)
                if (vodItem) {
                    let nextFocusRow = tempInfo.focusRow
                    let nextItemIndex = tempInfo.foucsItem + 1
                    if (nextItemIndex >= grid._getRowItemLength(nextFocusRow)) {
                        nextFocusRow++
                        nextItemIndex = 0
                        if (nextFocusRow >= grid.uiList.length) {
                            nextFocusRow = 0
                        }
                    }
                    tempInfo.focusRow = nextFocusRow
                    tempInfo.foucsItem = nextItemIndex
                    if (!vodItem.blockItem) {
                        exit = true
                    }
                } else {
                    grid = this.navigation.getCurrentGrid()
                    if (grid.type == GRIDTYPE.DYNID) {
                        dynidGrid = undefined
                        const tmpArry = this.navigation.continuesStack.slice(0, this.navigation.continuesStack.length - 1)
                        grid = tmpArry.length > 0 ? tmpArry[tmpArry.length - 1] : null
                        if (grid == null) {
                            vodItem = null
                            exit = true
                        } else {
                            tempInfo = grid.getFocusInfo()
                        }
                    } else {
                        if (vodItem == null) {
                            exit = true
                        }
                    }

                }
            }
            resolve(vodItem)

        })
    }

    getNextItem = async (): Promise<ItemNode> => {

        let gridViewModel = this.navigation.getCurrentGrid()
        let currentVodInfo = gridViewModel.getFocusedItem()
        let shouldreturnOnDynid = false;
        if (gridViewModel.type !== GRIDTYPE.DYNID &&
            (this.dynidGrid &&
            this.dynidGrid.mlpId == currentVodInfo.node_id &&
            this.dynidGrid.getRowAt(0) &&
            this.dynidGrid.getRowAt(0)?.initFetcingStatus == REQUEST_STATUS.OK)
        ) {
            if (gridViewModel.type === GRIDTYPE.SIMILAR_VIDEOS || gridViewModel.type === GRIDTYPE.QUEUE) {
                this.navigation.continuesStack.pop()
            }
            this.navigation.push(this.dynidGrid)
            gridViewModel = this.navigation.getCurrentGrid()
            currentVodInfo = gridViewModel.getFocusedItem()
            shouldreturnOnDynid = true;
        }
        // removed the nested dynid  condition
        // else if (gridViewModel.type == GRIDTYPE.DYNID && !Helper.isEmpty(currentVodInfo.deeplink_url)) {
        //     this.loadDynid(currentVodInfo.deeplink_url, currentVodInfo.node_id)
        //     await this.dynidGrid.fetchInitialRows()
        //     this.navigation.pop()
        //     this.navigation.push(this.dynidGrid)
        //     gridViewModel = this.navigation.getCurrentGrid()
        //     currentVodInfo = gridViewModel.getFocusedItem()
        //     shouldreturnOnDynid = true;
        // }
        if (shouldreturnOnDynid) {
            if (!this.blockingManager.isItemBlocked(currentVodInfo)) {
                return currentVodInfo;
            }
        }
        let vodInfo = null
        let exit = false
        // this loop is the scenario for the nested mlp / mlp last video if the current playing
        // video is the last element in the nested mlp se need to pop out and if previous level mlp is also the last element we need to recursively pop out of the stack.
        while (!exit) {
            vodInfo = await gridViewModel.getNextItem()!
            if (vodInfo == null) {
                if (gridViewModel.type == "deeplink") {
                    let focusInfo = gridViewModel.getFocusInfo();
                    focusInfo.foucsItem = 0;
                    gridViewModel.changeFocus(focusInfo);
                    vodInfo = gridViewModel.getFocusedItem();
                } else if (gridViewModel.type === GRIDTYPE.TOP_CAROUSEL) {
                    this.navigation.continuesStack.pop()
                    gridViewModel = this.navigation.getCurrentGrid()
                    const firstItemFocus = { focusRow: 0, foucsItem: 0 }
                    gridViewModel.changeFocus(firstItemFocus)
                    vodInfo = gridViewModel.getFocusedItem()
                } else if (gridViewModel.type === GRIDTYPE.QUEUE) {
                    // Same as the generic case below, minus the destroy(): queueGrid is shared with
                    // the main grid's Queue row, so destroying it here would wipe that row too.
                    this.navigation.continuesStack.pop()
                    gridViewModel = this.navigation.getCurrentGrid()
                    vodInfo = (await gridViewModel.getNextItem())!
                } else {
                    gridViewModel.destroy();
                    this.navigation.pop();
                    gridViewModel = this.navigation.getCurrentGrid()
                    vodInfo = (await gridViewModel.getNextItem())!
                }
            }
            if (vodInfo && !vodInfo.blockItem) {
                exit = true
            }
        }
        exit = false
        // this loop is for entering into the nested levels if the next item in the current level grid is a MLP Item.
        while (!exit) {
            if (vodInfo?.type == 'listoflist' || vodInfo.type == 'new-qid' || vodInfo.feed_type == 'banner') {
                const listGrid: GridViewModel = this.loadShow(vodInfo, vodInfo.id)
                await listGrid.fetchInitialRows()
                listGrid.createGridListUI()
                vodInfo = listGrid.getFocusedItem()
            } else {
                exit = true
            }
        }
        return vodInfo
    }

    getPrevItem = async (): Promise<ItemNode> => {
        let gridViewModel = this.navigation.getCurrentGrid()
        let currentVodInfo = gridViewModel.getFocusedItem()
        let shouldreturnOnDynid = false;
        if (gridViewModel.type !== GRIDTYPE.DYNID &&
            this.dynidGrid &&
            this.dynidGrid.mlpId == currentVodInfo.node_id
        ) {
            if (gridViewModel.type === GRIDTYPE.SIMILAR_VIDEOS || gridViewModel.type === GRIDTYPE.QUEUE) {
                this.navigation.continuesStack.pop()
            }
            this.navigation.push(this.dynidGrid)
            gridViewModel = this.navigation.getCurrentGrid()
            currentVodInfo = gridViewModel.getFocusedItem()
            shouldreturnOnDynid = true;
        }
        // removed the nested dynid  condition
        // else if (gridViewModel.type == GRIDTYPE.DYNID && !Helper.isEmpty(currentVodInfo.deeplink_url)) {
        //     this.loadDynid(currentVodInfo.deeplink_url, currentVodInfo.node_id)
        //     await this.dynidGrid.fetchInitialRows()
        //     this.navigation.pop()
        //     this.navigation.push(this.dynidGrid)
        //     gridViewModel = this.navigation.getCurrentGrid()
        //     currentVodInfo = gridViewModel.getFocusedItem()
        //     shouldreturnOnDynid = true;
        // }
        if (shouldreturnOnDynid) {
            if (!this.blockingManager.isItemBlocked(currentVodInfo)) {
                return currentVodInfo;
            }
        }
        let vodInfo = null
        let exit = false
        while (!exit) {
            vodInfo = (await gridViewModel.getPrevItem())!
            if (vodInfo == null) {
                if (!gridViewModel.parentGrid) {
                    let focusInfo = gridViewModel.getFocusInfo();
                    focusInfo.foucsItem = 0;
                    gridViewModel.changeFocus(focusInfo);
                    vodInfo = gridViewModel.getFocusedItem();
                } else {
                    gridViewModel.destroy();
                    this.navigation.pop();
                    gridViewModel = this.navigation.getCurrentGrid()
                    vodInfo = (await gridViewModel.getPrevItem())!
                }
            }
            if (vodInfo && !vodInfo.blockItem) {
                exit = true
            } else if (
                gridViewModel.getFocusInfo().focusRow == 0 &&
                gridViewModel.getFocusInfo().foucsItem == 0 &&
                !gridViewModel.parentGrid
            ) {
                if (vodInfo && !vodInfo.blockItem) {
                    // if the main grid or standalone grid 1st item is reached and is blocked
                    // traverse forward to pick the next unblock item
                    vodInfo = await this.getNextItem()
                    exit = true
                }
            }
        }
        exit = false
        while (!exit) {
            if (vodInfo.type == 'listoflist' || vodInfo.type == 'new-qid' || vodInfo.feed_type == 'banner') {
                const listGrid: GridViewModel = this.loadShow(vodInfo, vodInfo.id)
                await listGrid.fetchInitialRows()
                listGrid.createGridListUI()
                vodInfo = listGrid.getFocusedItem()
                if (vodInfo && vodInfo.blockItem) {
                    vodInfo = await listGrid.getNextItem()
                }
            } else {
                exit = true
            }
        }
        return vodInfo
    }
    initAdHandler = () => {
        if (!this.adHandler.isInitialized) {
            this.adHandler.createAdVideoElem();
            this.imaAdHandler.setUpIMA();
            this.adHandler.initializeAdsConfig();
        }
    }

    clearRecentlyWatched(nodeId?: string){
        return new Promise((resolve, reject)=>{
            const url = clearRecentlyWatched(nodeId)
            Log.info('Index.php request: ', url)
            // Router.focusPage()
            fetchData(url).then((response) => {
                if(nodeId) {
                    this.removeSingleNodeRemoval(nodeId)
                } else {
                this.navigation.getCurrentGrid().resetGrid()
                }
                // Router.reload()
                resolve(true)
            })
        })

    }

    removeSingleNodeRemoval(nodeId?: any) {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        const mainGridList: GridViewModel[] = app?.navigation.continuesStack.filter(gridview => {
            return gridview.type == GRIDTYPE.GRID
        })!
        if (mainGridList.length == 0) return;
        const mainGrid = mainGridList[0]!
        const recentlyRow: any = mainGrid.getRowAt(0)
        const removeIndex = recentlyRow.videos.findIndex((item: any) => {
            return item.node_id === nodeId || item.id === nodeId
        })
        if (removeIndex !== -1) {
            recentlyRow.videos.splice(removeIndex, 1)
            recentlyRow.videosCount = recentlyRow.videosCount - 1
        }

        const rowIndex = mainGrid.uiList.findIndex(
            (uiRow: any) => uiRow.data.item.rowList.name.toLowerCase() === 'recently watched'
        )
        if (rowIndex !== -1) {
            const updatedRow = mainGrid.getUiRowAt(rowIndex)
            updatedRow.data.item.rowList = recentlyRow

            if (recentlyRow.videos.length > 0) {
                let newFocusIndex = removeIndex
                if (removeIndex >= recentlyRow.videos.length) {
                    newFocusIndex = 0
                }
                updatedRow.data.focusItem = newFocusIndex
                mainGrid.update(recentlyRow, rowIndex, updatedRow)
                mainGrid.changeFocus({
                    focusRow: rowIndex,
                    foucsItem: newFocusIndex
                })
            } else {
                mainGrid.remove(rowIndex)
            }

        }
        Log.info('removeSingleRecentFromUI: item removed and UI updated', nodeId)
    }

}
